import { createReducer, on } from '@ngrx/store';
import * as baseState from '../../../core/models/base-state/base-state';
import { MedicalRecordNotification } from '../../models/medical-record-notification';
import * as actions from '../actions/medical-record.actions';

export const medicalRecordFeatureKey = 'medical-record';

export interface MedicalRecordState {
  baseState: baseState.BaseState;
  notifications: MedicalRecordNotification | null;
}

export const initialState: MedicalRecordState = {
  baseState: baseState.createBaseState(undefined),
  notifications: null,
};

export const medicalRecordReducer = createReducer<MedicalRecordState>(
  initialState,
  on(
    actions.getMedicalRecordNotifications,
    (state): MedicalRecordState => ({
      ...state,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: true,
      },
    })
  ),
  on(
    actions.getMedicalRecordNotificationsSuccess,
    (state, { notifications }): MedicalRecordState => ({
      ...state,
      notifications,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: false,
      },
    })
  ),
  on(
    actions.getMedicalRecordNotificationsFailure,
    (state, { error }): MedicalRecordState => ({
      ...state,
      baseState: {
        ...state.baseState,
        error,
        isLoading: false,
      },
    })
  )
);
